export const GITHUB_URL = 'https://github.com/JoosepAlviste/serieslist'
